import { cva } from '@/styled-system/css';

export const legendRecipe = cva({
  base: {
    color: 'Legend.text.default',
    cursor: 'default',
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {},
    },
    required: {
      true: {
        _after: {
          content: '"*" / ""',
          color: 'Legend.indicator.required',
          marginInlineStart: 'FormField.labelArea.gap.label-toRequired',
        },
      },
      false: {},
    },
    optional: {
      true: {
        _after: {
          content: '"(optional)"',
          color: 'Legend.indicator.optional',
          fontWeight: '{normal}',
          marginInlineStart: 'FormField.labelArea.gap.label-toOptional',
        },
      },
      false: {},
    },
    size: {
      md: {
        textStyle: 'body-sm-bold',
      },
      lg: {
        textStyle: 'body-bold',
      },
    },
  },
});
